<template>

    <main>
        <div></div>
        <div>
            <CorendonLoading :text="routeText"/>
<!--            <button class="btn btn-info" @click="gotoWebSite">Go to Website</button>-->
        </div>
    </main>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import CorendonLoading from "./CorendonLoading";


    export default {
        name: "SingleSignOnRouter",
        mixins: [loadingMixin],

        data() {
            return {
                selectedProject: this.$route.params.selectedProject,
                routeText: "Projeye yönlendiriliyorsunuz..."

            }
        },
        components: {
            CorendonLoading
        },
        methods: {
            ...mapActions('projects', ['getProjects', 'getProjectOfUser']),
            async gotoWebSite() {
                try {
                    await this.getProjects();
                    let project = this.requestedProject();
                    let mainRoute = project[0].mainRoute;
                    console.log("mainRoute")
                    console.log(mainRoute)
                    let route = mainRoute + this.user.email + ","+ localStorage.getItem("refresh_token");
                    console.log("route");
                    console.log(route);
                    window.location.href=route;
                }catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});
                }
            },

            requestedProject() {
                try {
                    return this.projects.filter((post) => {
                        return post.projectCode == this.selectedProject;
                    });
                }catch (e) {
                    this.$notify({title:"Error",type:"error",text:e.message});
                }
            }
        },
        computed: {
            //...mapState('projects', ['projects', 'projectsOfUser']),
            ...mapState("auth", ["user"]),
            ...mapState("projects",["projects"]),




        },
        beforeMount() {
            console.log("beforeMount");
            console.log(this.selectedProject);
            console.log(this.$route)

            setTimeout(() => {this.gotoWebSite()},1500);

        },
        created() {
        }
    }
</script>

<style scoped>

</style>